"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderWrapper = exports.HeaderSection = exports.Header = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _atoms = require("../atoms");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var HeaderWrapper = (0, _styledComponents["default"])(_atoms.Flex).attrs({
  alignItems: 'center'
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
exports.HeaderWrapper = HeaderWrapper;
var HeaderSection = (0, _styledComponents["default"])(_atoms.Flex).attrs({
  justifyContent: 'center',
  flex: '1'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  :first-child > ", " {\n    margin-right: auto;\n  }\n\n  :last-child > ", " {\n    margin-left: auto;\n  }\n"])), HeaderWrapper, HeaderWrapper);
exports.HeaderSection = HeaderSection;

var Header = function Header(_ref) {
  var leftComponents = _ref.leftComponents,
      centerComponents = _ref.centerComponents,
      rightComponents = _ref.rightComponents,
      children = _ref.children;
  return (0, _jsxRuntime.jsxs)(_atoms.Box, {
    backgroundColor: "header.background",
    sx: {
      zIndex: '1',
      boxShadow: '0px 100px 80px rgba(0, 0, 0, 0.02), 0px 64px 47px rgba(0, 0, 0, 0.015), 0px 38px 25.4815px rgba(0, 0, 0, 0.012), 0px 20px 13px rgba(0, 0, 0, 0.01), 0px 8px 6px rgba(0, 0, 0, 0.008), 0px 2px 3px rgba(0, 0, 0, 0.005)'
    },
    children: [(0, _jsxRuntime.jsx)(_atoms.Container, {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      minHeight: "90px",
      children: (0, _jsxRuntime.jsxs)(_atoms.Flex, {
        children: [(0, _jsxRuntime.jsx)(HeaderSection, {
          children: (0, _jsxRuntime.jsx)(HeaderWrapper, {
            mx: "-16px",
            children: leftComponents !== null && leftComponents !== void 0 ? leftComponents : null
          })
        }), (0, _jsxRuntime.jsx)(HeaderSection, {
          children: (0, _jsxRuntime.jsx)(HeaderWrapper, {
            children: centerComponents !== null && centerComponents !== void 0 ? centerComponents : null
          })
        }), (0, _jsxRuntime.jsx)(HeaderSection, {
          children: (0, _jsxRuntime.jsx)(HeaderWrapper, {
            mr: "-16px",
            children: rightComponents !== null && rightComponents !== void 0 ? rightComponents : null
          })
        })]
      })
    }), children]
  });
};

exports.Header = Header;